/**
 * Created by Christof Sander on 20.10.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	]
};